import React from 'react';
import { Center } from '@fiverr-private/layout_components';
import { Types, theme } from '@fiverr-private/theme';
import { AIDevelopmentIcon } from '../icons/AIDevelopmentIcon';
import { B2BMarketingIcon } from '../icons/B2BMarketingIcon';
import { CampaignsIcon } from '../icons/CampaignsIcon';
import { ContentCreationMarketingIcon } from '../icons/ContentCreationMarketingIcon';
import { CryptoIcon } from '../icons/CryptoIcon';
import { DevOpsIcon } from '../icons/DevOpsIcon';
import { ECommerceMarketingIcon } from '../icons/ECommerceMarketingIcon';
import { ECommerceStoresIcon } from '../icons/ECommerceStoresIcon';
import { GameDevelopmentIcon } from '../icons/GameDevelopmentIcon';
import { ITIcon } from '../icons/ITIcon';
import { MarketingStrategyIcon } from '../icons/MarketingStrategyIcon';
import { MobileAppDevelopmentIcon } from '../icons/MobileAppDevelopmentIcon';
import { PRIcon } from '../icons/PRIcon';
import { PresenceIcon } from '../icons/PresenceIcon';
import { ProductDevelopmentIcon } from '../icons/ProductDevelopmentIcon';
import { PromotionIcon } from '../icons/PromotionIcon';
import { SoftwareDevelopmentIcon } from '../icons/SoftwareDevelopmentIcon';
import { UIDesignIcon } from '../icons/UIDesignIcon';
import { WebsiteDevelopmentIcon } from '../icons/WebsiteDevelopmentIcon';
import { FinancialConsultingIcon } from '../icons/FinancialConsultingIcon';
import { AccountIcon } from '../icons/AccountIcon/AccountIcon';
import { MarketResearchIcon } from '../icons/MarketResearchIcon';
import { BusinessPlansIcon } from '../icons/BusinessPlansIcon';
import { BusinessConsultingIcon } from '../icons/BusinessConsultingIcon';
import { ProductManagementIcon } from '../icons/ProductManagementIcon';
import { DigitalConsultingIcon } from '../icons/DigitalConsultingIcon';
import { HRIcon } from '../icons/HRICon';
import { ELearningIcon } from '../icons/ELearningIcon';
import { LegalIcon } from '../icons/LegalIcon';
import { ECommerceIcon } from '../icons/ECommerceIcon';
import { BackOfficeIcon } from '../icons/BackOfficeIcon';
import { CallCenterIcon } from '../icons/CallCenterIcon';
import { WebAppDesignIcon } from '../icons/WebAppDesignIcon';
import { VisualIdentityIcon } from '../icons/VisualIdentityIcon';
import { MarketingIcon } from '../icons/MarketingIcon';
import { PrintDesignIcon } from '../icons/PrintDesignIcon';
import { PublicationIcon } from '../icons/PublicationIcon';
import { ContentCreationIcon } from '../icons/ContentCreationIcon';
import { ArchitectureIcon } from '../icons/ArchitectureIcon';
import { IndustrialIcon } from '../icons/IndustrialIcon';
import { FashionIcon } from '../icons/FashionIcon';
import { GameCreationIcon } from '../icons/GameCreationIcon';
import { VideoEditingIcon } from '../icons/VideoEditingIcon';
import { VideoShootIcon } from '../icons/VideoShootIcon';
import { AdvertisingIcon } from '../icons/AdvertisingIcon';
import { ExplainerIcon } from '../icons/ExplainerIcon';
import { UGCIcon } from '../icons/UGCIcon';
import { ProductVideosIcon } from '../icons/ProductVideosIcon';
import { CorporateVideosIcon } from '../icons/CorporateVideosIcon';
import { SocialMediaVideosIcon } from '../icons/SocialMediaVideosIcon';
import { AnimationIcon } from '../icons/AnimationIcon';

const ITEM_COLORS = ['purple', 'lightOrange', 'green', 'pink', 'teal', 'orange', 'blue', 'red', 'yellow'];

/* Object keys represent real service ids */
const MAP_SERVICE_ID_TO_ICON = {
    1: MobileAppDevelopmentIcon,
    23: ECommerceStoresIcon,
    12: WebsiteDevelopmentIcon,
    33: UIDesignIcon,
    39: SoftwareDevelopmentIcon,
    48: ProductDevelopmentIcon,
    59: AIDevelopmentIcon,
    71: ITIcon,
    81: DevOpsIcon,
    85: GameDevelopmentIcon,
    101: CryptoIcon,
    108: PromotionIcon,
    118: PresenceIcon,
    137: ECommerceMarketingIcon,
    154: CampaignsIcon,
    172: B2BMarketingIcon,
    188: ContentCreationMarketingIcon,
    205: PRIcon,
    213: MarketingStrategyIcon,
    220: FinancialConsultingIcon,
    227: AccountIcon,
    241: MarketResearchIcon,
    249: BusinessPlansIcon,
    260: BusinessConsultingIcon,
    270: ProductManagementIcon,
    277: DigitalConsultingIcon,
    303: HRIcon,
    319: ELearningIcon,
    325: LegalIcon,
    328: ECommerceIcon,
    351: BackOfficeIcon,
    378: CallCenterIcon,
    422: WebAppDesignIcon,
    414: VisualIdentityIcon,
    446: MarketingIcon,
    463: PrintDesignIcon,
    475: PublicationIcon,
    484: ContentCreationIcon,
    501: ArchitectureIcon,
    522: IndustrialIcon,
    543: FashionIcon,
    553: GameCreationIcon,
    566: VideoEditingIcon,
    581: VideoShootIcon,
    597: AdvertisingIcon,
    627: ExplainerIcon,
    640: UGCIcon,
    653: ProductVideosIcon,
    669: CorporateVideosIcon,
    690: SocialMediaVideosIcon,
    714: AnimationIcon,
};

interface PreviewItemIconProps {
    itemIndex: number;
    itemServiceId: number;
}

export const PreviewItemIcon = ({ itemIndex, itemServiceId }: PreviewItemIconProps) => {
    const itemColor = ITEM_COLORS[itemIndex % ITEM_COLORS.length];

    const Icon = MAP_SERVICE_ID_TO_ICON[itemServiceId] || WebsiteDevelopmentIcon;

    return (
        <Center
            width="72px"
            height="72px"
            borderRadius="md"
            backgroundColor={`${itemColor}_100` as Types.SelectorBackgroundColorsType}
            marginBottom="4"
        >
            <Icon color={theme.colors[`${itemColor}_1200`]} />
        </Center>
    );
};
